import axios, { AxiosResponse } from "axios";
import getConfig from "../config/configUtil";

const conf = getConfig;

export interface EcuGroup {
    title: string;
    models: string[];
}

class EcuService {
  async getEcus(): Promise<EcuGroup[]> {
    try {
      const response: AxiosResponse = await axios.get(conf.BACKEND + "ecus/all");

      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error("Failed to fetch ECUs");
    }
  }
}

export default EcuService;
